interface SectionDividerProps {
  variant?: "wave" | "zigzag" | "slant" | "swoosh" | "doublewave";
  fillClass?: string;
  flip?: boolean;
}

/**
 * SectionDivider
 * --------------
 * The wavy / cloud-style dividers were retired — they didn't fit the
 * brand vibe. This now renders nothing so all existing usages remain
 * harmless. Sections transition with their own background colors.
 */
export default function SectionDivider(_props: SectionDividerProps) {
  return null;
}
